import React, { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getInterview } from "../../redux/action";
import { AppDispatch } from "../../redux/store";
import {
  getFeedbackForm,
  getLoading,
  getProfileForm,
} from "../../redux/reducer/incbotFeedbackReducer";
import { generateUrl } from "../../utils/helper";
import skeletonLoad from "../../assets/gifs/skeleton-load.gif";
import { Loader } from "../ui/loader";
import IncbotFeedbackIndex from "./incbotFeedback/Index";
import CefrFeedbackIndex from "./cefrFeedback/Index";
import NotFound from "./notFound/NotFound";

/**
 * Fetches interview and renders incbotFeedback or cefrFeedback UI based on interviewType.
 */
const FeedbackRouter = () => {
  const { roomId = "", interviewId = "" } = useParams();
  const [searchParams] = useSearchParams();
  const signature = searchParams.get("signature") || "";
  const expires = searchParams.get("expires") || "";
  const dispatch = useDispatch<AppDispatch>();
  const profileForm = useSelector(getProfileForm);
  const feedbackForm = useSelector(getFeedbackForm);
  const loading = useSelector(getLoading);

  useEffect(() => {
    dispatch(getInterview({ roomId, interviewId, signature, expires }));
  }, [dispatch, roomId, interviewId, signature, expires]);

  if (loading || !feedbackForm) {
    return <Loader gifSrc={skeletonLoad} size="xxl" fullscreen />;
  }

  if (
    feedbackForm &&
    "feedbackTemplate" in feedbackForm &&
    feedbackForm?.feedbackTemplate === false
  ) {
    const currentUrl = new URL(window.location.href);
    const pathname = currentUrl.pathname.replace("/incbot", "");
    const newUrl = new URL(
      `${generateUrl("meeting")}/feedback/room${pathname}${currentUrl.search}`
    );
    window.location.href = newUrl.toString();
    return <Loader gifSrc={skeletonLoad} size="xxl" fullscreen />;
  }

  if (!profileForm || !feedbackForm) {
    return <NotFound expired={true} />;
  }

  if (!(feedbackForm?.version > 10 || feedbackForm?.feedbackTemplate)) {
    return <NotFound />;
  }

  // Render CEFR UI when interviewType is "cefr"
  if (profileForm?.interviewType === "cefr_interview") {
    return <CefrFeedbackIndex />;
  }

  return <IncbotFeedbackIndex skipFetch />;
};

export default FeedbackRouter;
